import { render, staticRenderFns } from "./ReportVendors.vue?vue&type=template&id=5bd84778&"
import script from "./ReportVendors.vue?vue&type=script&lang=js&"
export * from "./ReportVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd84778')) {
      api.createRecord('5bd84778', component.options)
    } else {
      api.reload('5bd84778', component.options)
    }
    module.hot.accept("./ReportVendors.vue?vue&type=template&id=5bd84778&", function () {
      api.rerender('5bd84778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/ReportVendors.vue"
export default component.exports